"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.inviteUserThunk = exports.removeUserThunk = exports.fetchUsersThunk = void 0;
const axios_1 = __importDefault(require("src/utils/axios"));
const axios_2 = require("axios");
const actions_1 = require("./actions");
const actions_2 = require("src/stores/exportedStore/loader/actions");
const fetchUsersThunk = () => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .get("/api/v1/app/users/")
        .then((res) => {
        dispatch((0, actions_1.setUsers)(res.data));
    })
        .catch(console.log)
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
};
exports.fetchUsersThunk = fetchUsersThunk;
const removeUserThunk = (id) => (dispatch) => {
    dispatch((0, actions_2.setLoading)(true));
    axios_1.default
        .post(`/api/v1/app/users/${id}/delete/`)
        .then((res) => {
        dispatch((0, exports.fetchUsersThunk)());
    })
        .catch(console.log)
        .finally(() => dispatch((0, actions_2.setLoading)(false)));
};
exports.removeUserThunk = removeUserThunk;
const inviteUserThunk = ({ data, setIsLoading, setErrors, setShow }) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch((0, actions_2.setLoading)(true));
    setIsLoading(true);
    axios_1.default
        .post(`/api/v1/app/users/`, data)
        .then((res) => {
        setShow(false);
        dispatch((0, exports.fetchUsersThunk)());
    })
        .catch((err) => {
        if ((0, axios_2.isAxiosError)(err)) {
            setErrors(err.response.data);
            return;
        }
        throw new Error(err);
    })
        .finally(() => {
        dispatch((0, actions_2.setLoading)(false));
        setIsLoading(false);
    });
});
exports.inviteUserThunk = inviteUserThunk;
